import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData, putData, updateData, deleteData, activateData, SyncData } from '../../../apiService'; // Assuming putData is used for updating
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SyncIcon from '@mui/icons-material/Sync';
import ReactDOM from 'react-dom';
import ReturnBillPrint from './Bill';
const SaleReturnDetails = () => {
    const { id } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [DateInvoice, setDateInvoice] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [TripId, setTripId] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [qty, setQty] = useState('');
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [saleData, setSaleData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [itemnameget, setItemName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [ReturnTaxableAmt, setReturnTaxableAmt] = useState('');
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [getDate, setGetData] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [RQuantities, setRQuantities] = useState([]);
    const [currentDisplayedDate, setCurrentDisplayedDate] = useState(null);
    const [showSelectedInvoice, setShowSelectedInvoice] = useState(false);
    const [ReturnId, setReturnIdId] = useState(null);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [remark, setRemark] = useState("");
    // const [Isdelete, setIsdelete] = useState(false);
    const [RouteName, setRouteName] = useState('');
    const [searchQuery, setSearchQuery] = useState(""); // State for search query
    const [formData, setFormData] = useState({
        datas: {
            CustomerId: '',
            CustomerName: '',
            Remark: '',
            RQuantity: '',
        }
    });
    const [getDatesale, setGetDatasale] = useState({
        datas: {
            RQuantity: '',
        }
    });

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        fetchSaleReturnData();
    }, []);
    const fetchSaleReturnData = async () => {
        try {
            setLoading(true);
            const response = await fetchData('ReturnApi', `/SaleReturn/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data);
                const array = response.response_data;
                console.log(response);
                setTripId(response.response_data.TripId);
                const selectedcustomerOption = customerOptions.find(option => option.value === response.response_data.CustomerId);
                setSelectedCustomerType(selectedcustomerOption);
                setCustomerId(response.response_data.CustomerId)
                setRouteName(response.response_data.Route)
            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
        finally {
            setLoading(false);
        }
    };

    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };


    //scroll
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? '#f0f0f0' : provided.backgroundColor,
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
    };
    const handleRefreshClick = () => {
        window.location.reload();
    };

    useEffect(() => {
        fetchtableReturnData();
    }, []);


    const AddtoListdata = (e) => {
        e.preventDefault();
        const updatedItem = { quantity: parseInt(qty) };
        setItemList([...itemList, updatedItem]);
        setNewItem({
            quantity: 1,
        });
        setSelectedItem(null);
        setQty('');
    };
    /////////table data
    const fetchtableReturnData = async () => {
        try {
            const response = await fetchData('ReturnSaleOrderApi', `/SaleReturn/${id}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setGetData(response.response_data);
                setGetDatasale(response.response_data);
                setReturnIdId(response.response_data.map(item => item.ID));
                setDateInvoice(dataArray[0].invoiceDate);
                console.log(response);
                setRQuantities(response.response_data.map(item => item.RQuantity));
            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
    };

    const truncate2 = (num) => Math.trunc(num * 100) / 100;

    // calculation {gst, taxable values...........}
    function calculateTotalAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        const igstAmount = 0;
        const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
        return isNaN(totalAmount) ? 0 : Math.round(totalAmount);
    }

    function calculateGst(rapeperpeice, gstrate, quantities, bagweight) {
        const cgstAmount = calculateCGST(rapeperpeice, gstrate, quantities, bagweight);
        const sgstAmount = calculateSGST(rapeperpeice, gstrate, quantities, bagweight);
        const igstAmount = 0;
        const gst = cgstAmount + sgstAmount + igstAmount;
        return isNaN(gst) ? 0 : truncate2(gst).toFixed(2);

    }

    function calculateCGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        return cgstAmount;
    }

    function calculateSGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        return sgstAmount;
    }

    function taxableAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        //  const SRTaxable = taxableAmount.flatMap(item => item.taxableAmount);

        return isNaN(taxableAmount) ? 0 : taxableAmount.toFixed(2);

    }


    const combinedInvoiceData = selectedInvoices.flatMap(invoice => invoice.data);



    const [newItem, setNewItem] = useState({
        Id: '',
        quantity: 1,
    });


    const filteredDatatable = getDate.filter(item =>
        item.ItemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB').includes(searchQuery.toLowerCase())

    );


    const [itemList, setItemList] = useState([]);
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [itemName, setItemNames] = useState('');

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };
    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setDeleteItemId(null);
        setItemNames('');
        setConfirmDialogOpen(true);
    };

    const ConfirmDialog = (deleteItemId, itemname) => {
        setItemToDeleteIndex(null);
        setDeleteItemId(deleteItemId);
        setItemName(itemname)
        setConfirmDialogOpen(true);
    };



    //const dataItem = getData[index]; 
    const invoiceDates = getDate.flatMap(item => item.invoiceDate);

    const totalValues = filteredDatatable.reduce((acc, item, idx) => {
        const rQuantity = RQuantities[idx] || 0;
        const itemTotal = {
            itemRatePerKg: acc.itemRatePerKg + item.ItemRatePerKg,
            discountPerPiece: acc.discountPerPiece + item.DiscountPerPiece,
            rateAfterDiscount: acc.rateAfterDiscount + item.RateAfterDiscount,
            quantity: acc.quantity + item.Quantity,
            gstRate: acc.gstRate + item.GSTRate,
            returnRateAfterDiscount: acc.returnRateAfterDiscount + item.RateAfterDiscount,
            rQuantities: acc.rQuantities + rQuantity,
            totalQty: acc.totalQty + (item.ItemBagWeight * rQuantity),
            taxableAmt: acc.taxableAmt + taxableAmount(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight),
            gst: acc.gst + calculateGst(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight),
            netAmt: acc.netAmt + calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight)
        };
        return itemTotal;
    }, {
        itemRatePerKg: 0,
        discountPerPiece: 0,
        rateAfterDiscount: 0,
        quantity: 0,
        gstRate: 0,
        returnRateAfterDiscount: 0,
        rQuantities: 0,
        totalQty: 0,
        taxableAmt: 0,
        gst: 0,
        netAmt: 0
    });

    const handleSaleReturnPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('SaleReturnApi', `/SaleReturnDetailsPrint/${companyId}/${id}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <ReturnBillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();

            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }

    };

    return (
        <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ maxWidth: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '2000px', overflowY: 'auto' }}>
            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginLeft: '-5px', marginTop: '-20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', overflowY: 'auto' }}>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <h5 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown', textAlign: 'left', marginTop: '-15px' }}>SALE RETURN DETAILS</h5>

                <h4 className="flex-grow  font-serif" style={{ marginLeft: '45%', marginTop: '-50px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontSize: '18px', color: '#A25772' }}>
                    Route :{' '}
                    {formData.Route}
                </h4>
                <div className="flex mb-2" style={{ marginTop: '20px' }}>
                    <h6 className="flex-grow" style={{ fontSize: '16px', color: '#45273A', fontWeight: 'bold' }}>
                        Credit Note No: CN{formData.ReturnNo}/{formData.FinYear} </h6>
                    <h6 className="flex-grow" style={{ marginLeft: '-140px', fontSize: '16px', color: '#1E2A5E' }}>
                        Return Date: {''}
                        {formatDateForInput(formData.ReturnDate)}
                    </h6>
                    <h6 className="flex-grow" style={{ marginLeft: '-150px', fontSize: '16px', color: '#B8001F' }}>
                        Customer :{' '}
                        {formData.CustomerName}
                    </h6>
                </div>

                
                <div className="flex mb-2" style={{ justifyContent: "flex-end" , marginTop: '-2%' }}>
                    <Tooltip title="Sale Return Bill">
                        <Button
                            onClick={() => handleSaleReturnPrint(id)}
                            style={{
                                background: '#D76C82',
                                color: 'white',
                                fontWeight: '600',
                                marginLeft: '10px',
                                fontSize: '12px',
                                height: '30px'
                            }}
                        >
                            Print
                        </Button>
                    </Tooltip>

                    <Tooltip title="Sale Return Edit">
                        <Link to={`/SaleReturnEdit/${id}`}>
                            <Button
                                style={{
                                    background: '#FFA62F',
                                    color: 'white',
                                    fontWeight: '600',
                                    marginLeft: '10px',
                                    fontSize: '12px',
                                    height: '30px'
                                }}
                            >
                                Sale Return <SyncIcon />
                            </Button>
                        </Link>
                    </Tooltip>

                    <Tooltip title="Back To List">
                        <Link to="/Ledger" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button
                                variant="contained"
                                color="error"
                                style={{
                                    marginLeft: '10px',
                                    height: '30px'
                                }}
                            >
                                Back <ExitToAppIcon />
                            </Button>
                        </Link>
                    </Tooltip>
                </div>

                <br />

                <div className="w-full mb-4 flex">

                    <TableContainer component={Paper}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px', fontSize: '14px', fontWeight: 'normal' }}>Sl.No</th>
                                    <Tooltip title="Sale Date"><th style={{ width: '50px', fontSize: '14px', fontWeight: 'normal' }}>S.Date</th></Tooltip>
                                    <Tooltip title="Sale Bill No"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>Bill No</th></Tooltip>
                                    <Tooltip title="Item Name"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>Name</th></Tooltip>
                                    <Tooltip title="Rate"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>Rate<p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(per piece)</p></th></Tooltip>
                                    <th style={{ fontSize: '14px', fontWeight: 'normal' }}>Discount</th>
                                    <Tooltip title="Sale Rate"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>Rate <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(after discount)</p></th></Tooltip>
                                    <Tooltip title="Sale Quantity"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>S.Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces) </p></th></Tooltip>
                                    <th style={{ fontSize: '14px', fontWeight: 'normal' }}>GST %</th>
                                    <Tooltip title="Return Rate"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>R.Rate</th></Tooltip>
                                    <Tooltip title="Return Quantity"><th style={{ fontSize: '14px', width: '85px', fontWeight: 'normal' }}>R.Qty <p style={{ fontSize: '10px', marginBlock: ' -7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th></Tooltip>
                                    <Tooltip title="Total Quantity"><th style={{ width: '80px', fontSize: '14px', fontWeight: 'normal' }}>Total Qty</th></Tooltip>
                                    <Tooltip title="Taxable Amount"><th style={{ width: '100px', fontSize: '14px', fontWeight: 'normal' }}>Taxable Amt</th></Tooltip>
                                    <th style={{ fontSize: '14px', fontWeight: 'normal' }}>GST</th>
                                    <Tooltip title="Net Amount"><th style={{ fontSize: '14px', fontWeight: 'normal' }}>Net Amt</th></Tooltip>

                                </tr>
                            </thead>
                            <tbody>

                                {filteredDatatable.map((item, index) => (
                                    <tr key={index}>
                                        <td className="border-r">{index + 1}</td>
                                        <td className=" border-r">  {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-GB') : ''}</td>
                                        <td className=" border-r" style={{ color: 'brown', fontWeight: 'bold' }}>{item.Prefix}{item.InvoiceNo}/{item.FinYear}</td>

                                        <td className="border-r" style={{ color: 'blueviolet' }}>{item.ItemName}</td>
                                        <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.ItemRatePerKg).toFixed(2)}</td>
                                        <td className="border-r" style={{ textAlign: 'right' }}>
                                            {item.DiscountPerPiece}
                                        </td>
                                        <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                        <td className="border-r" style={{ textAlign: 'right' }}>{item.Quantity}</td>
                                        <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.GSTRate)}</td>
                                        <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                        <td className="border-r" style={{ fontSize: '14px', width: '80px', textAlign: 'Right' }}>
                                            {RQuantities[index] || ''}
                                        </td>
                                        <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(item.ItemBagWeight * RQuantities[index]) ? '0.00' : (item.ItemBagWeight * RQuantities[index])}</td>

                                        <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)}</td>
                                        <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{isNaN(calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : (calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight))}</td>
                                        <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)}</td>

                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr >
                                    <td className="border-r text-left text-sm " colSpan="7" style={{}}>TOTAL</td>
                                
                                    <td className="border-r text-right text-sm" style={{}}>{filteredDatatable.reduce((acc, item) => acc + item.Quantity, 0)}</td>
                                    <td className="px-4 py-2 border-r text-right text-sm" style={{}}></td>
                                    <td className="border-r text-right text-sm" style={{ backgroundColor: '#F1D3CE', color: 'brown', fontWeight: 'bold', fontSize: '14px' }}>{filteredDatatable.reduce((acc, item) => acc + item.RateAfterDiscount, 0).toFixed(2)}</td>
                                    <td className="border-r text-right text-sm" style={{}}>
                                        {filteredDatatable.reduce((acc, item, idx) => acc + (parseInt(RQuantities[idx]) || 0), 0)}
                                    </td>

                                    <td className=" border-r text-right text-sm" style={{}}>
                                        {filteredDatatable.reduce((acc, item, idx) => {
                                            const weight = Number(item.ItemBagWeight);
                                            const qty = RQuantities[idx];
                                            if (!isNaN(weight) && !isNaN(qty)) {
                                                return acc + (weight * qty);
                                            }
                                            return acc;
                                        }, 0)}
                                    </td>
                                    <td className="border-r text-right text-sm" style={{ backgroundColor: '#FEFBD8', color: 'brown', fontWeight: 'bold', fontSize: '14px' }}>
                                        {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                    </td>
                                    <td className="border-r text-right text-sm" style={{}}>
                                        {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                    </td>
                                    <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: '#C7FFD8', color: 'brown', fontWeight: 'bold', fontSize: '14px' }}>
                                        {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                    </td>

                                </tr>
                            </tfoot>

                        </table>

                    </TableContainer>
                </div>
            </div>
        </div >


    );
};

export default SaleReturnDetails;
